// 📁 src/redux/slices/dateOptionsSlice.ts

import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

// ✅ Types
interface DateOption {
  label: string;
  value: string;
}

interface FetchDateParams {
  page?: number;
  limit?: number;
  searchTerm?: string | null | any;
 DATE?:any;         // changed toany
  TITLE?:any;
  FILE_NAME?:any;
}


interface TitleState {
  TitleOption: any;
  loadingOfTitle: boolean;
  error: string | null;
  hasMore: boolean;
  currentPage: number;
  limit: number;
  LoadingOFAll:boolean;
  LoadingofkddTitle:boolean;
  LoadingofkddFile:boolean;
dataOfTitle:any
}

// ✅ Initial State
const initialState: TitleState = {
  TitleOption: [],
  loadingOfTitle: false,
  error: null,
  hasMore: true,
  currentPage: 1,
  limit: 10,
  LoadingOFAll:false,
  LoadingofkddTitle:false,
  LoadingofkddFile:false,
  dataOfTitle:''
};

export const FetchTitleOptions = createAsyncThunk(
  "FetchTitleOptions",
  async (params: FetchDateParams = {}, { rejectWithValue }) => {
    console.log("page in reducer", params.page);
    try {
       const queryParams: string[] = [];

      if (params.page !== undefined) queryParams.push(`page=${params.page}`);
      if (params.limit !== undefined) queryParams.push(`limit=${params.limit}`);
      if (params.searchTerm !== undefined)queryParams.push(`searchTerm=${params.searchTerm}`);
      // if (params.DATE?.length) queryParams.push(`DATE=${params.DATE}`);
       if (Array.isArray(params.DATE)) {
        params.DATE.forEach(date => {
          queryParams.push(`DATE=${encodeURIComponent(date)}`);
        });
      }
        if (Array.isArray(params.TITLE)) {
        params.TITLE.forEach(title => {
          queryParams.push(`TITLE=${encodeURIComponent(title)}`);
        });
      }
        if (Array.isArray(params.FILE_NAME)) {
        params.FILE_NAME.forEach(file => {
          queryParams.push(`FILE_NAME=${encodeURIComponent(file)}`);
        });
      }
      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      const response = await axios.get(
        `${API.GETTITLEOPTIONSINKDD}${queryString}`
      );

      return { data: response.data, page: params.page ?? 1 };
    } catch (err: any) {
      if (err.response?.data) {
        return rejectWithValue(err.response.data);
      }
      return rejectWithValue("error occurred");
    }
  }
);

// ✅ Slice
const dateOptionsSlice = createSlice({
  name: "dateOptions",
  initialState,
  reducers: {
    clearDateOptions: (state) => {
      //   state.TitleOption = [];
      //   state.currentPage = 1;
      //   state.hasMore = true;
      //   state.loading = false;
      //   state.error = null;
    },
    SetLoadingOFAll:(state,action)=>{
      state.LoadingOFAll=action.payload
    },
    SetLoadingofkddTitle:(state,action)=>{
      state.LoadingofkddTitle=action.payload
    },
    SetLoadingofkddFile:(state,action)=>{
      state.LoadingofkddFile=action.payload
    },
    setdataOfTitle:(state,action)=>{
      state.dataOfTitle=action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(FetchTitleOptions.pending, (state) => {
        state.loadingOfTitle = true;
        // state.status = "loadingOfTitle";
      })
      .addCase(FetchTitleOptions.fulfilled, (state, action) => {
        state.loadingOfTitle = false;
        const { data, page } = action.payload;
        const titledata = (data.title_options || []).map((item: string) => ({
          label: item,
          value: item,
        }));
        console.log(titledata, "titledata");
        if (page === 1) {
          state.TitleOption = titledata;
        } else {
          state.TitleOption = [...state.TitleOption, ...titledata];
        }

        state.currentPage = page;
        state.hasMore = data.hasMore;
        state.loadingOfTitle = false;
      })
      .addCase(FetchTitleOptions.rejected, (state) => {
        state.loadingOfTitle = false;
        // state.status = "Failed";
        state.error = "Error";
      });
  },
});

// ✅ Export Actions and Reducer
export const { clearDateOptions,SetLoadingOFAll,SetLoadingofkddTitle,SetLoadingofkddFile,setdataOfTitle } = dateOptionsSlice.actions;
export default dateOptionsSlice.reducer;
